import pubsub from '@/lib/pubsub'
import { createApp } from 'vue'
import { goToPurchase } from '@/lib/purchase-utils'
import paywallModal from '@/components/paywall-modal'

import subscriptionService from '@/services/subscription-service'

/**
 * Class responsible for pay wall logic and popups
 */
export default class Paywall {
  /**
   * Check the user's account level and subscriptions to determine access. Basic users
   * will not be allowed to upload photos.
   *
   * @return {bool} Returns bool whether user has access or not
   */
  static checkAccess() {
    let hasAccess = true

    // Check the account popover for any subscriptions
    const subscriptions = document.querySelectorAll(
      '#account-popover .membership-active'
    )

    if (
      subscriptionService.getMembershipLevel() === 'basic' &&
      subscriptions.length === 0
    ) {
      hasAccess = false
    }

    return hasAccess
  }

  /**
   * Display a pay wall message
   */
  static displayPayWallMessage(type) {
    Paywall.displayBasicPayWallMessage(type)
  }

  /**
   * Display the basic user paywall message
   */
  static displayBasicPayWallMessage(type) {
    const upgradeLabel = 'Upgrade Plan'

    const paywallPopup = createApp(paywallModal, {
      type: type,
      upgradeLabel: upgradeLabel,
    }).provide('theme', 'fish')

    // Mount the modal dialog to the modal wrapper defined in the main html page
    paywallPopup.mount('#modal-wrapper')

    // FUTURE: This is a temporary work around. Eventually we will have all of our
    // handlebar templates moved over to vue components. When we do that, we won't
    // need to create this component in this manner. According to
    // https://v3.vuejs.org/guide/migration/events-api.html#_2-x-syntax the
    // INSTANCE_EVENT_EMITTER is not longer supported in Vue 3.
    pubsub.subscribe('close-paywall-popup', () => {
      paywallPopup.unmount()
    })

    // FUTURE - this could be handled in the paywallModal
    pubsub.subscribe('create-paywall', () => {
      goToPurchase({
        origin: type,
        detail: upgradeLabel,
      })
      paywallPopup.unmount()
    })
  }
}
